import { useContext, useMemo } from 'react';
import SoftPullStatus from '~/constants/softPullStatus';
import FinancingType from '~/constants/srp/FinancingType';
import FinanceContext from '~/context/vdp/FinanceContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useIsInSptOnVdpExperiment from '../useIsInSptOnVdpExperiment';

export default function useSoftPullStatus() {
  const {
    userFinancing: { data: cjsFinancing, isLoaded: isCjsLoaded }
  } = useContext(FinanceContext);
  const {
    vdpPricingInfo: {
      data: {
        financeInfo: { financingType = FinancingType.EstimatedFinancing } = {}
      },
      isLoaded: isVdpPricingLoaded
    }
  } = useContext(UserVehicleContext);
  const isInSptOnVdpExperiment = useIsInSptOnVdpExperiment();

  return useMemo(() => {
    let softPullStatus: SoftPullStatus;

    if (isInSptOnVdpExperiment) {
      switch (financingType) {
        case FinancingType.Expired:
          softPullStatus = SoftPullStatus.Expired;
          break;
        case FinancingType.UserFinancing:
          softPullStatus = SoftPullStatus.Active;
          break;
        default:
          softPullStatus = SoftPullStatus.None;
          break;
      }

      return {
        softPullStatus,
        isLoaded: isVdpPricingLoaded
      };
    }

    if (cjsFinancing?.isValid == null) {
      softPullStatus = SoftPullStatus.None;
    } else {
      softPullStatus = cjsFinancing.isValid
        ? SoftPullStatus.Active
        : SoftPullStatus.Expired;
    }

    return {
      softPullStatus,
      isLoaded: isCjsLoaded
    };
  }, [
    cjsFinancing?.isValid,
    financingType,
    isCjsLoaded,
    isInSptOnVdpExperiment,
    isVdpPricingLoaded
  ]);
}
